export const NAVIGATION_LINK_TYPES = {
  DEEPLINK: 'deeplink',
  INTERNAL: 'internal',
  SERVICE: 'service',
};
